import { format } from 'date-fns';

// Compact duration: 3h 26m / 1h / 38m / <1m. Rounds to whole minutes (mockup never shows seconds).
export function formatDuration(ms) {
  const totalMinutes = Math.round(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) return `${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h`;
  if (minutes > 0) return `${minutes}m`;
  return `<1m`;
}

// "Jun 1, 2026 - Jun 30, 2026" for the panel sub-heading. Null when range is incomplete.
export function formatRangeLabel(range) {
  if (!range || !range.start || !range.end) return null;

  return `${format(new Date(range.start), 'MMM d, yyyy')} - ${format(new Date(range.end), 'MMM d, yyyy')}`;
}
